/**
 * 请求登录验证，如果没有登录，不能访问页面，返回到登录页面
 */
import router from ".";
import vuex from '../store/index'


//路由判断登录，根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  //查询token
  const token = localStorage.getItem('token')

  //已登录
  if (token) {
    //判断菜单是否加载
    if (!vuex.getters.isReady) {
      //查询菜单
      vuex.dispatch('initMenu').then(data => {
        router.loadPage(data)
        next({path: to.fullPath === '/' ? 'home' : to.path})
      })
    } else {
      next()
    }
    return
  }

  //未发现路由
  if (to === null) {
    next({path: '404'})
    return;
  }

  //登录页
  if (to.fullPath === '/') {
    next()
    return;
  }

  //其他跳到登录页
  next({path: '/'})
})

router.afterEach((to, from) => {
  vuex.commit('setActiveUrl', to.path)
  // console.log("afterEach:to = " + to.name + " , from=" + from.name)
})



// WEBPACK FOOTER //
// ./src/router/auth.js